import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setLoadingOverlay } from '../../store/slices/loadingOverlaySlice';
import { useEffect, useRef, useState } from 'react';
import LocalstorageService from '../../helpers/localstorage-service';
import { CompanyId, JobRole, USER_ROLE } from '../../constants';
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  Row,
  Table,
  UncontrolledTooltip,
} from 'reactstrap';
import MachineService from '../../services/machines';
import { useOutletContext } from 'react-router-dom';
import { t } from 'i18next';
import EmployeeService from '../../services/employee';
import { Form, Formik } from 'formik';
import ReactSelect from 'react-select';
import { NumericFormat } from 'react-number-format';
import ReactDatePicker from 'react-datepicker';
import NoRecords from '../../components/Table/NoRecords';
import SortableHeader from '../../components/SortableHeader';
import dragHandler from '../../assets/images/drag-handle.svg';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import EmployeeRemarkModal from '../../components/EmployeeRemarkModal';
import EmployeeCancelLoadModal from '../../components/EmployeeCancelLoadModal';
import warning from '../../assets/images/Warning.png';
import LocationService from '../../services/Location';
import EmpActivityService from '../../services/emp_activity';
import AlertModal from '../../components/AlertModal';
import { getIsraelBusinessDate } from '../../helpers/dateUtils';

const EmployeeLoadsList = () => {
  const dispatch = useDispatch();
  const login_emp = LocalstorageService.getItem('user-id');
  const roleId = LocalstorageService.getItem(JobRole);
  const selectedEmpId = localStorage.getItem('emp_id');
  const [setPageTitle, setCrumbItem] = useOutletContext();
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [empList, setEmpList] = useState([]);
  const [empId, setEmpId] = useState(roleId === USER_ROLE.COMPANY_ADMIN ? selectedEmpId || 0 : login_emp);
  const reqPayload = {};
  const formRef = useRef();
  const empListLoaded = useRef(false);
  let companyId = LocalstorageService.getItem(CompanyId);

  const [date, setDate] = useState(getIsraelBusinessDate);
  const [showRemarkModal, setShowRemarkModal] = useState({ shown: false, values: {} });
  const [showLoadingCancelModal, setShowLoadingCancelModal] = useState({ shown: false, value: {} });
  const [amount, setAmount] = useState('');
  const [totalLoadAmount, setTotalLoadAmount] = useState('');
  const [remainingAmount, setRemainingAmount] = useState(0);
  let role = LocalstorageService.getItem(JobRole);

  // isMobile as state that updates on resize
  const [isMobile, setIsMobile] = useState(window.innerWidth < 850);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 850);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ========== Row Order Mode States ==========
  const [orderMode, setOrderMode] = useState(false);        // סדר מקומות toggle
  const [permanentOrderMode, setPermanentOrderMode] = useState(false);  // סדר קבוע toggle
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);    // track if order was changed by drag
  const [showSaveTempModal, setShowSaveTempModal] = useState(false);    // modal for temp save
  const [showSavePermanentModal, setShowSavePermanentModal] = useState(false); // modal for permanent save
  // ================================================

  const InitialValues = {
    totalLoadAmount: '',
    employee: '',
    amount: '',
    allEmployee: true,
  };

  const [compConf, setCompConf] = useState({
    shown: false,
    msg: t('ALERT.EMPLOYEE_ZERO_AMOUNT_LOAD'),
    confirmFn: () => {
      setCompConf((pre) => ({ ...pre, shown: false }));
    },
  });

  useEffect(() => {
    setPageTitle(t('EMPLOYEE_LOADS.TITLE'));
    setCrumbItem([
      { title: t('APPLICATION_TITLE'), link: '#' },
      { title: t('EMPLOYEE_LOADS.TITLE'), link: '#' },
    ]);
    // getEmployeeFn moved into loadAllData for parallel execution with data calls
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchRemainCash(reqPayload) {
    dispatch(setLoadingOverlay(true));
    await LocationService.getRemainCash(reqPayload)
      .then((response) => {
        const { data } = response.data;
        setRemainingAmount(data?.totalCashRemain || 0);
      })
      .finally(() => {
        dispatch(setLoadingOverlay(false));
      });
  }

  const fetchRecords = () => {
    reqPayload.companyId = companyId;
    reqPayload.dateS = date.toLocaleDateString('en-US');
    reqPayload.employeeId = empId || 0;
    listFn();
  };

  const moveToNextDayAfterNoon = () => {
    let timerId = null;
    const israelTimeZone = 'Asia/Jerusalem';

    const getNextDate = (currentDate) => {
      const nextDate = new Date(currentDate);
      nextDate.setDate(currentDate.getDate() + 1);
      return nextDate;
    };

    const checkTime = () => {
      const date = new Date();
      const israelTime = date.toLocaleTimeString('en-US', {
        timeZone: israelTimeZone,
        hour12: false,
      });
      // שינוי שעה 18:00  (6 בערב)  משנה את התאריך למחר
      const currentHour = israelTime.split(':')[0];
      if (currentHour >= 18) {
        const nextDate = getNextDate(date);
        setDate(nextDate);
        clearInterval(timerId);
        timerId = null;
      }
    };

    timerId = setInterval(checkTime, 1000);
  };

  useEffect(() => {
    // Consolidated data loading with single loading overlay
    const loadAllData = async () => {
      const storeList = JSON.parse(localStorage.getItem('dataArray'));
      const storedDate = localStorage.getItem('date');
      const storedEmpiId = localStorage.getItem('emp_id');
      const currentSelectedDate = date.toDateString();
      const remondAmount = localStorage.getItem('remindAmount');

      const dateChanged = currentSelectedDate !== storedDate;
      const empChanged = parseInt(storedEmpiId) !== parseInt(empId);
      const isFirstLoad = !storedDate;

      dispatch(setLoadingOverlay(true));
      setIsLoading(true);

      try {
        const promises = [];

        // 0. Fetch employee list (only on first load)
        if (!empListLoaded.current) {
          promises.push(
            EmployeeService.listEmployee({ companyId })
              .then((response) => {
                const { status, dataList } = response.data;
                if (status !== 400 && dataList && dataList.length) {
                  const data = dataList.map((item) => ({
                    id: item.id,
                    label: `${item.firstName} ${item.lastName}`,
                    value: item.id,
                    companyId: item.companyId,
                  }));
                  data.unshift({
                    id: 0,
                    label: `${t(`LOADING_TERMINAL.ALL_EMPLOYEES`)}`,
                    value: 0,
                    companyId: companyId,
                  });
                  setEmpList(data);
                }
                empListLoaded.current = true;
              })
              .catch(() => { empListLoaded.current = true; })
          );
        }

        if (dateChanged || empChanged || isFirstLoad) {
          // נקה נתונים ישנים ואפס סכומים מיד
          setList([]);
          setTotalLoadAmount(0);
          setAmount(0);
          localStorage.removeItem('remindAmount');

          localStorage.setItem('date', currentSelectedDate);
          localStorage.setItem('emp_id', empId || '');
          localStorage.setItem('dataArray', JSON.stringify([]));

          // 1. Fetch terminal list
          promises.push(
            MachineService.terminalList({
              companyId: companyId,
              dateS: date.toLocaleDateString('en-US'),
              employeeId: empId || 0,
              sort: [{ value: 'rowOrder', asc: true }],
            }).then((response) => {
              const { status, message, dataList } = response.data;
              const dataArr = dataList !== null && dataList?.length > 0 ? dataList : [];
              if (status === 400) { toast.error(message); return; }
              let temp = 0;
              let processedList = dataArr.map((o) => {
                if (o.rowStatus === 0) temp += Number(o.loadingAmount);
                return { ...o, stats: o.rowStatus };
              });
              processedList = sortListForNormalDisplay(processedList);
              setList(processedList);
              setTotalLoadAmount(temp);
              localStorage.setItem('dataArray', JSON.stringify([]));
              localStorage.setItem('emp_id', '');
            }).catch(() => { setList([]); })
          );

          // 2. Get total amount to load
          promises.push(
            MachineService.toAmountToLoad({
              dateS: date.toLocaleDateString('en-US'),
              companyId: companyId,
              employeeId: empId !== 0 ? Number(empId) : 0,
            }).then((response) => {
              const { status, dataList } = response.data;
              if (status === 400) { setAmount(0); return; }
              if (dataList && dataList.length > 0) {
                setAmount(dataList[0].totalAmountToLoad || 0);
              } else { setAmount(0); }
            }).catch(() => setAmount(0))
          );
        } else {
          // אותו תאריך ואותו עובד - שימוש בנתונים מהזיכרון אם קיימים
          if (storeList && storeList.length > 0) {
            setList(storeList);
            if (remondAmount) {
              setTotalLoadAmount(Number(remondAmount));
            } else {
              let temp = 0;
              storeList?.forEach((value) => {
                if (value.rowStatus === 0) temp += Number(value.loadingAmount || 0);
              });
              setTotalLoadAmount(temp);
            }
          } else {
            setList([]);
            setTotalLoadAmount(0);
            // אין נתונים בזיכרון - טעינה מהשרת
            promises.push(
              MachineService.terminalList({
                companyId: companyId,
                dateS: date.toLocaleDateString('en-US'),
                employeeId: empId || 0,
                sort: [{ value: 'rowOrder', asc: true }],
              }).then((response) => {
                const { status, message, dataList } = response.data;
                const dataArr = dataList !== null && dataList?.length > 0 ? dataList : [];
                if (status === 400) { toast.error(message); return; }
                let temp = 0;
                let processedList = dataArr.map((o) => {
                  if (o.rowStatus === 0) temp += Number(o.loadingAmount);
                  return { ...o, stats: o.rowStatus };
                });
                processedList = sortListForNormalDisplay(processedList);
                setList(processedList);
                setTotalLoadAmount(temp);
              }).catch(() => { setList([]); })
            );
          }
          // עדיין צריך לקבל את הסכום הכללי מהשרת
          promises.push(
            MachineService.toAmountToLoad({
              dateS: date.toLocaleDateString('en-US'),
              companyId: companyId,
              employeeId: empId !== 0 ? Number(empId) : 0,
            }).then((response) => {
              const { status, dataList } = response.data;
              if (status === 400) { setAmount(0); return; }
              if (dataList && dataList.length > 0) {
                setAmount(dataList[0].totalAmountToLoad || 0);
              } else { setAmount(0); }
            }).catch(() => setAmount(0))
          );
        }

        // 3. Fetch remaining cash (always if empId exists)
        if (empId) {
          promises.push(
            LocationService.getRemainCash({ employeeId: empId })
              .then((response) => {
                const { data } = response.data;
                setRemainingAmount(data?.totalCashRemain || 0);
              })
              .catch(() => setRemainingAmount(0))
          );
        }

        // Execute all promises in parallel
        await Promise.all(promises);
      } finally {
        dispatch(setLoadingOverlay(false));
        setIsLoading(false);
      }
    };

    loadAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, empId]);

  const sortBy = (sortObj) => {
    delete reqPayload.sort;
    if (sortObj) {
      reqPayload['sort'] = [sortObj];
    }
    reqPayload.companyId = companyId;
    reqPayload.dateS = date.toLocaleDateString('en-US');
    reqPayload.employeeId = empId;
    listFn();
  };

  async function getEmployeeFn() {
    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    await EmployeeService.listEmployee({ companyId })
      .then((response) => {
        const { status, dataList } = response.data;
        if (status === 400) return;
        if (dataList && dataList.length) {
          const data = dataList.map((item) => ({
            id: item.id,
            label: `${item.firstName} ${item.lastName}`,
            value: item.id,
            companyId: item.companyId,
          }));
          data.unshift({
            id: 0,
            label: `${t(`LOADING_TERMINAL.ALL_EMPLOYEES`)}`,
            value: 0,
            companyId: companyId,
          });
          setEmpList(data);
        }
      })
      .finally(() => {
        setIsLoading(false);
        dispatch(setLoadingOverlay(false));
      });
  }

  async function getTotalAmountToLoad(payload) {
    const getPayload = {
      ...payload,
      employeeId: payload.employeeId !== 0 ? Number(payload.employeeId) : payload.employeeId,
    };
    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    await MachineService.toAmountToLoad(getPayload)
      .then((response) => {
        const { status, dataList } = response.data;
        if (status === 400) {
          setAmount(0);
          return;
        }
        if (dataList && dataList.length > 0) {
          setAmount(dataList[0].totalAmountToLoad || 0);
        } else {
          // אין נתונים - לאפס את הסכום
          setAmount(0);
        }
      })
      .catch(() => {
        setAmount(0);
      })
      .finally(() => {
        setIsLoading(false);
        dispatch(setLoadingOverlay(false));
      });
  }

  // ========== Check if order toggles should be enabled ==========
  const canUseOrderMode = () => {
    if (roleId === USER_ROLE.COMPANY_ADMIN) {
      return empId && empId !== 0 && empId !== '0';
    }
    return true;
  };

  // Check if we're in any ordering mode (show drag handles instead of load button)
  const isInOrderingMode = () => orderMode;
  // ====================================================

  const HeaderList = [
    // כפתור טעינה
    {
      title: '',
      value: '',
      className: 'tableSbtBtn',
      style: { width: isMobile ? '45px' : '55px', maxWidth: isMobile ? '45px' : '55px', minWidth: isMobile ? '45px' : '55px' },
      sortable: false,
    },
    // שם עסק - הגדלת הרוחב ל-180 בדסקטופ כדי למנוע חפיפה עם כפתור בוצע
    {
      title: t(`LOAD_TABS.BUSINESS_NAME_LABEL`),
      value: 'locationName',
      style: isMobile
        ? { width: 'auto', minWidth: '80px' }
        : { width: '180px', maxWidth: '180px', minWidth: '180px' },
      sortable: false,
    },
    // סכום לטעינה
    {
      title: t(`LOAD_TABS.AMOUNT_TO_LOAD_LABEL`),
      value: 'loadingAmount',
      style: { width: isMobile ? '65px' : '100px', maxWidth: isMobile ? '65px' : '100px', minWidth: isMobile ? '65px' : '100px' },
      sortable: false,
    },
    // הערות (רק במחשב) - יתפרס על כל הרוחב הנותר
    ...(!isMobile ? [{
      title: t(`LOAD_TABS.REMARKS_LABEL`),
      value: 'remark',
      style: {},  // ללא הגבלת רוחב - יתפרס אוטומטית
      sortable: false,
    }] : []),
    // כפתור הערה
    {
      title: '',
      value: '',
      className: 'tableRemarkBtn',
      style: { width: isMobile ? '40px' : '70px', minWidth: isMobile ? '40px' : '70px', maxWidth: isMobile ? '40px' : '70px' },
      sortable: false,
    },
    // כפתור ביטול
    {
      title: '',
      value: '',
      className: 'tableCnlBtn',
      style: { width: isMobile ? '40px' : '70px', minWidth: isMobile ? '40px' : '70px', maxWidth: isMobile ? '40px' : '70px' },
      sortable: false,
    },
  ];

  // ========== Sort list for normal display ==========
  // Normal mode: amount > 0 first (by TempRowOrder), then amount = 0 (by TempRowOrder)
  const sortListForNormalDisplay = (dataArr) => {
    return dataArr
      .slice()
      .sort((a, b) => {
        // First: prioritize amount > 0
        if (a.loadingAmount > 0 && b.loadingAmount === 0) return -1;
        if (a.loadingAmount === 0 && b.loadingAmount > 0) return 1;
        // Then sort by TempRowOrder (or RowOrder if TempRowOrder not set)
        return (a.tempRowOrder || a.rowOrder || 9999) - (b.tempRowOrder || b.rowOrder || 9999);
      })
      .sort((a, b) => {
        // Finally sort by status: 0 (pending), 1 (done), -1 (cancelled)
        const order = [0, 1, -1];
        const indexA = order.indexOf(a.stats);
        const indexB = order.indexOf(b.stats);
        if (indexA === -1 && indexB !== -1) return -1;
        if (indexA !== -1 && indexB === -1) return 1;
        return indexA - indexB;
      });
  };

  // Sort list for permanent order mode (by RowOrder only, all items)
  const sortListByPermanentOrder = (dataArr) => {
    return dataArr.slice().sort((a, b) => {
      return (a.rowOrder || 9999) - (b.rowOrder || 9999);
    });
  };

  // ========== Main list fetch function ==========
  async function listFn(rerender = 0) {
    if (rerender !== 0) {
      reqPayload.companyId = companyId;
      reqPayload.dateS = date.toLocaleDateString('en-US');
      reqPayload.employeeId = empId;
    }
    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    // fetchRemainCash removed - already called by loadAllData to avoid duplicate calls

    await MachineService.terminalList({
      ...reqPayload,
      sort: [{ value: 'rowOrder', asc: true }],
    })
      .then((response) => {
        const { status, message, dataList } = response.data;
        const dataArr = dataList !== null && dataList?.length > 0 ? dataList : [];
        if (status === 400) {
          toast.error(message);
          return;
        }

        let temp = 0;

        // Map data and calculate totals
        let processedList = dataArr.map((o) => {
          if (o.rowStatus === 0) {
            temp += Number(o.loadingAmount);
          }
          return { ...o, stats: o.rowStatus };
        });

        // Always sort for normal display when fetching
        processedList = sortListForNormalDisplay(processedList);

        setList(processedList);
        setTotalLoadAmount(temp);

        if (rerender === 0) {
          localStorage.setItem('dataArray', JSON.stringify([]));
          localStorage.setItem('emp_id', '');
        } else {
          localStorage.setItem('dataArray', JSON.stringify(processedList));
        }
      })
      .finally(() => {
        dispatch(setLoadingOverlay(false));
        setIsLoading(false);
      });
  }

  // ========== Handle Order Mode Toggle ==========
  const handleOrderModeToggle = (newValue) => {
    if (!newValue && orderMode) {
      // Turning OFF order mode
      if (hasUnsavedChanges) {
        // Show save temp modal
        setShowSaveTempModal(true);
      } else {
        // No changes - just exit order mode
        exitOrderMode();
      }
    } else if (newValue) {
      // Turning ON order mode - keep same display, just enable drag
      setOrderMode(true);
      setHasUnsavedChanges(false);
    }
  };

  const handlePermanentOrderToggle = (newValue) => {
    if (!newValue && permanentOrderMode) {
      // Turning OFF permanent mode
      if (hasUnsavedChanges) {
        // Show save permanent modal
        setShowSavePermanentModal(true);
      } else {
        // No changes - exit permanent mode, return to normal display
        exitPermanentMode();
      }
    } else if (newValue) {
      // Turning ON permanent mode - show items sorted by RowOrder
      setPermanentOrderMode(true);
      setHasUnsavedChanges(false);
      // Re-sort list by permanent order
      const sortedList = sortListByPermanentOrder(list);
      setList(sortedList);
    }
  };

  // Exit order mode completely and return to normal display
  const exitOrderMode = () => {
    setOrderMode(false);
    setPermanentOrderMode(false);
    setHasUnsavedChanges(false);
    setShowSaveTempModal(false);
    setShowSavePermanentModal(false);
    // Refresh list with normal display
    listFn(1);
  };

  // Exit permanent mode but stay in order mode
  const exitPermanentMode = () => {
    setPermanentOrderMode(false);
    setHasUnsavedChanges(false);
    setShowSavePermanentModal(false);
    // Return to normal display (still in order mode with drag handles)
    const sortedList = sortListForNormalDisplay(list);
    setList(sortedList);
  };

  // Save temp order and exit to normal display
  const saveTempOrder = async () => {
    const rowOrderData = list.map((item, index) => ({
      terminalNumber: item.terminalNumber,
      rowOrder: index + 1,
    }));

    setIsLoading(true);
    dispatch(setLoadingOverlay(true));

    try {
      const response = await MachineService.saveTempRowOrder({
        companyId,
        employeeId: empId,
        rowOrderData,
        dateS: date.toLocaleDateString('en-US'), // Add date parameter
      });

      if (response.data.status === 200) {
        toast.success(t('EMPLOYEE_LOADS.TEMP_ORDER_SAVED') || 'הסדר הזמני נשמר');
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.message || 'שגיאה בשמירת הסדר');
    } finally {
      setIsLoading(false);
      dispatch(setLoadingOverlay(false));
      exitOrderMode();
    }
  };

  // Save permanent order and exit to normal display
  const savePermanentOrder = async () => {
    const rowOrderData = list.map((item, index) => ({
      terminalNumber: item.terminalNumber,
      rowOrder: index + 1,
    }));

    setIsLoading(true);
    dispatch(setLoadingOverlay(true));

    try {
      const response = await MachineService.savePermanentRowOrder({
        companyId,
        employeeId: empId,
        rowOrderData,
        dateS: date.toLocaleDateString('en-US'), // Add date parameter
      });

      if (response.data.status === 200) {
        toast.success(t('EMPLOYEE_LOADS.PERMANENT_ORDER_SAVED') || 'הסדר הקבוע נשמר');
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.message || 'שגיאה בשמירת הסדר');
    } finally {
      setIsLoading(false);
      dispatch(setLoadingOverlay(false));
      exitOrderMode();
    }
  };

  // Cancel temp order changes
  const cancelTempOrderChanges = () => {
    exitOrderMode();
  };

  // Cancel permanent order changes
  const cancelPermanentOrderChanges = () => {
    exitPermanentMode();
  };
  // ==================================================

  const handleCharginTerminal = async (values) => {
    const {
      employeeId,
      sumOfTerminalDrawer,
      locationId,
      terminalNumber,
      manuallyCounted,
      clearReader,
      drawer,
      batch,
      loadingAmount,
      companyId,
    } = values;
    const leadingBatch = terminalNumber?.slice(3);
    const payload = {
      batch,
      employeeId,
      locationId,
      terminalNumber,
      manuallyCounted,
      cleaningCardReader: clearReader || false,
      wasIndrawer: sumOfTerminalDrawer,
      amountemployeehave: remainingAmount,
      drawer,
      leadingBatch,
      companyId,
      addBills: Number(loadingAmount) / 100,
    };
    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    try {
      const response = await EmpActivityService.chargeTerminal(payload);
      const { status, message, data } = response.data;

      if (status === 400) {
        toast.error(message);
        return;
      }

      if (response.data.status === 200) {
        const employeeLoadingTerminalId = data?.employeeLoadingTerminalId || 0;

        const submitPayload = {
          employeeId,
          companyId,
          terminalNumber,
          dateS: date.toLocaleDateString('en-US'),
          rowStatus: 1,
          employeeLoadingTerminalId: employeeLoadingTerminalId,
        };
        const submitResponse = await MachineService.manageCancelSubmitRowOrder(submitPayload);
        const { status: submitStatus, message: submitMessage } = submitResponse.data;

        if (submitStatus === 400) {
          toast.error(submitMessage);
          return;
        }

        sortAfterSuccess({ ...values });
        toast.success(submitMessage);
        setShowRemarkModal({ shown: false });
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || 'שגיאה בטעינת המסוף';
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
      dispatch(setLoadingOverlay(false));
    }
  };

  const handleCancelTerminal = async (values) => {
    const { employeeId, terminalNumber, companyId } = values;

    const payload = {
      employeeId,
      companyId,
      terminalNumber,
      dateS: date.toLocaleDateString('en-US'),
      rowStatus: -1,
    };

    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    await MachineService.manageCancelSubmitRowOrder(payload)
      .then((response) => {
        const { status, message } = response.data;

        if (status === 400) {
          toast.error(message);
          return;
        }
        sortAfterSuccess({ ...values });
        toast.success(message);
        setShowRemarkModal({ shown: false });
      })
      .catch((err) => {
        toast.error(err?.message || 'שגיאה בביטול הטעינה');
      })
      .finally(() => {
        setIsLoading(false);
        dispatch(setLoadingOverlay(false));
      });
  };

  const handleCancelCompletedLoading = async (values) => {
    const { employeeId, terminalNumber, companyId, cancelNote } = values;

    const payload = {
      employeeId,
      companyId,
      terminalNumber,
      createDate: date.toLocaleDateString('en-US'),
      cancelNote: cancelNote || values.remark || '',
    };

    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    try {
      const response = await MachineService.cancelEmployeeLoading(payload);
      const { status, message } = response.data;

      if (status === 400) {
        toast.error(message);
        return;
      }

      const listArray =
        JSON.parse(localStorage.getItem('dataArray')) && JSON.parse(localStorage.getItem('dataArray')).length > 0
          ? JSON.parse(localStorage.getItem('dataArray'))
          : list;

      const updatedList = listArray.map(item => {
        if (item.terminalNumber === terminalNumber) {
          return { ...item, stats: 0 };
        }
        return item;
      });

      const sortedArray = sortListForNormalDisplay(updatedList);

      localStorage.setItem('dataArray', JSON.stringify(sortedArray));
      setList(sortedArray);

      if (empId) {
        fetchRemainCash({ employeeId: empId });
      }

      toast.success(message);
      setShowLoadingCancelModal({ shown: false });
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || 'שגיאה בביטול הטעינה';
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
      dispatch(setLoadingOverlay(false));
    }
  };

  const sortAfterSuccess = (values) => {
    const listArray =
      JSON.parse(localStorage.getItem('dataArray')) && JSON.parse(localStorage.getItem('dataArray')).length > 0
        ? JSON.parse(localStorage.getItem('dataArray'))
        : list;
    const cancelledEntry = listArray.filter((entry) => entry.terminalNumber === values.terminalNumber);
    listArray.splice(listArray.indexOf(cancelledEntry[0]), 1);
    listArray.push({ ...values, stats: values.status === 1 ? 1 : values.status === 2 ? -1 : 0 });

    let loadingAmount = values.loadingAmount;
    if (listArray.length > 0 && values.status === 1) {
      let temp = 0;

      if (typeof loadingAmount === 'string') {
        loadingAmount = loadingAmount.replaceAll(',', '');
      }

      temp = Number(totalLoadAmount) - Number(loadingAmount);
      if (empId) {
        fetchRemainCash({ employeeId: empId });
      }
      setTotalLoadAmount(temp);
      localStorage.setItem('remindAmount', temp);
    }
    const sortedArray = sortListForNormalDisplay(listArray);
    localStorage.setItem('date', new Date().toDateString());
    localStorage.setItem('emp_id', empId);
    localStorage.setItem('dataArray', JSON.stringify(sortedArray));
    setList(sortedArray);
  };

  const handleSubmit = (values) => {
    const listArray =
      JSON.parse(localStorage.getItem('dataArray')) && JSON.parse(localStorage.getItem('dataArray')).length > 0
        ? JSON.parse(localStorage.getItem('dataArray'))
        : list;
    let loadingAmount = values.loadingAmount;
    if (listArray.length > 0 && values.status === 1) {
      if (typeof loadingAmount === 'string') {
        loadingAmount = loadingAmount.replaceAll(',', '');
      }
    }
    if (values.status === 1) {
      handleCharginTerminal({ ...values, loadingAmount });
    } else if (values.status === 3) {
      handleCancelCompletedLoading({ ...values });
    } else {
      handleCancelTerminal({ ...values });
    }
  };

  // ========== Handle Drag End ==========
  const handleDragEnd = async (result) => {
    const { destination, source } = result;

    if (!destination || destination.index === source.index) return;

    const listArray = [...list];
    const removed = listArray.splice(source.index, 1);
    listArray.splice(destination.index, 0, removed[0]);

    // Update indices
    for (let i = 0; i < listArray.length; i++) {
      listArray[i]['index'] = i;
    }

    setList(listArray);
    setHasUnsavedChanges(true); // Mark that we have unsaved changes

    localStorage.setItem('dataArray', JSON.stringify(listArray));
    localStorage.setItem('date', new Date().toDateString());
    localStorage.setItem('emp_id', empId);
  };

  let fieldDecimalScale = 0;
  let useThousandSeparator = true;

  return (
    <>
      <Formik
        innerRef={formRef}
        initialValues={InitialValues}
      >
        {({ values, setFieldValue, setFieldTouched }) => (
          <Form noValidate>
            <Row className="formRow">
              <Col sm={4}>
                <div className="formColumn mb-3">
                  <label className="me-2">{t(`LOADING_TERMINAL.EMPLOYEE`)}</label>
                  <ReactSelect
                    name={'employee'}
                    value={empList.filter(({ value }) => value === parseInt(empId))}
                    options={empList}
                    className="react-select"
                    onChange={(option) => {
                      setFieldValue('employee', option?.value);
                      setEmpId(option?.value);
                      // Reset order modes when changing employee
                      setOrderMode(false);
                      setPermanentOrderMode(false);
                      setHasUnsavedChanges(false);
                    }}
                    onBlur={() => setFieldTouched('employee', true)}
                    placeholder={`-- ${t('LOADING_TERMINAL.EMPLOYEE')} --`}
                    noOptionsMessage={() => t('RSEL_NO_OPT')}
                    isDisabled={roleId !== USER_ROLE.COMPANY_ADMIN}
                  />
                </div>
              </Col>
              <Col sm={3}>
                <div className="formColumn mb-3">
                  <label className="datePickerLabel me-2">{t('EMPLOYEE_LOADS.DATE')}</label>
                  <ReactDatePicker
                    name="date"
                    className="form-control w-50"
                    selected={date}
                    onChange={(dateArr) => setDate(dateArr)}
                    dateFormat={'dd/MM/yyyy'}
                    shouldCloseOnSelect={true}
                    highlightDates={[new Date()]}
                  />
                </div>
              </Col>

              {/* ========== Order Mode Toggles ========== */}
              <Col sm={4}>
                <div className="d-flex align-items-center gap-3">
                  {/* סדר מקומות toggle */}
                  <div className="d-flex align-items-center">
                    <label className="me-2" style={{ whiteSpace: 'nowrap' }}>
                      {t('EMPLOYEE_LOADS.ORDER_MODE') || 'סדר מקומות'}
                    </label>
                    <div className="form-check form-switch">
                      <Input
                        type="switch"
                        role="switch"
                        checked={orderMode}
                        onChange={(e) => handleOrderModeToggle(e.target.checked)}
                        disabled={isLoading || !canUseOrderMode()}
                      />
                    </div>
                  </div>

                  {/* סדר קבוע toggle - only visible when orderMode is on */}
                  {orderMode && (
                    <div className="d-flex align-items-center">
                      <label className="me-2" style={{ whiteSpace: 'nowrap' }}>
                        {t('EMPLOYEE_LOADS.PERMANENT_ORDER') || 'סדר קבוע'}
                      </label>
                      <div className="form-check form-switch">
                        <Input
                          type="switch"
                          role="switch"
                          checked={permanentOrderMode}
                          onChange={(e) => handlePermanentOrderToggle(e.target.checked)}
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </Col>
              {/* ============================================= */}

              <Col sm={1}>
                <div className="d-flex justify-content-end">
                  <Button id={`refresh`} className="h-5" color="primary" type="button" onClick={() => fetchRecords()}>
                    <UncontrolledTooltip placement="right" target={`refresh`}>
                      {t('EMPLOYEE_LOADS.REFRESH_BTN')}
                    </UncontrolledTooltip>
                    <i className="ri-refresh-line"></i>
                  </Button>
                </div>
              </Col>
            </Row>

            <div className="dataMin employeeLoads">
              <Table
                className="fixTh dataTable"
                striped
                bordered
                responsive
                size="sm"
                style={{ minWidth: '600px' }}
              >
                <thead>
                  <tr className="TableRow dropable">
                    <SortableHeader headers={HeaderList} isDisabled={list.length === 0} sortClick={sortBy} showActionCol={false} />
                  </tr>
                </thead>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="table">
                    {(provided, snapshot) => (
                      <tbody
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {list?.map((item, index) => {
                          // Check if item has a non-empty remark
                          const remarkValue = item.remark;
                          const hasRemark = remarkValue != null &&
                            remarkValue !== '' &&
                            String(remarkValue).trim() !== '' &&
                            String(remarkValue).trim() !== '-';

                          // Determine remark color based on type
                          const getRemarkColor = () => {
                            if (!hasRemark) return 'inherit';
                            const remarkStr = String(remarkValue || '').trim();
                            if (remarkStr.includes('נא לנקות קורא כרטיסים')) {
                              return '#FCB92C'; // Orange/Yellow - card reader cleaning
                            } else if (remarkStr.includes('פעם אחרונה שהמסוף נספר')) {
                              return '#008000'; // Green - manual counting
                            }
                            return '#FF0000'; // Red - other remarks
                          };
                          const remarkColor = getRemarkColor();

                          return (
                            <Draggable
                              isDragDisabled={!isInOrderingMode() || item?.stats !== 0}
                              draggableId={item.terminalNumber}
                              index={index}
                              key={item.terminalNumber}
                            >
                              {(provided, snapshot) => (
                                <tr
                                  id={item.terminalNumber}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  className={`TableRow ${item?.stats === -1 ? 'disabledRow' : ''}`}
                                  key={item.terminalNumber}
                                >
                                  {/* Column 1: Submit button OR Drag handle based on mode */}
                                  <td className="tableSbtBtn" style={{ width: isMobile ? '45px' : '55px', maxWidth: isMobile ? '45px' : '55px' }}>
                                    {isInOrderingMode() ? (
                                      // Show drag handle in ordering mode
                                      <div {...provided.dragHandleProps} style={{ cursor: item?.stats === 0 ? 'grab' : 'not-allowed' }}>
                                        <img
                                          src={dragHandler}
                                          height={'20px'}
                                          width={'20px'}
                                          alt=""
                                          style={{ opacity: item?.stats === 0 ? 1 : 0.3 }}
                                        />
                                      </div>
                                    ) : (
                                      // Show submit button in normal mode
                                      <Button
                                        disabled={item?.stats === 1 || item?.stats === -1}
                                        color={`${item?.stats === 1 ? 'success' : 'primary'}`}
                                        className="tableBtn"
                                        onClick={() => {
                                          item.loadingAmount >= 0
                                            ? setShowRemarkModal({ shown: true, values: { ...item, index, date } })
                                            : setCompConf((pre) => ({ ...pre, shown: true }));
                                        }}
                                      >
                                        {isMobile ? <i className="ri-check-line"></i> : item?.stats === 0 || item?.stats === -1
                                          ? t(`LOAD_REMARKS.SUBMIT_BTN`)
                                          : t(`EMPLOYEE_LOADS.DONE_BTN`)}
                                      </Button>
                                    )}
                                  </td>

                                  {/* Business name - הגדלת הרוחב ל-180 בדסקטופ */}
                                  <td
                                    className="text-nowrap"
                                    style={{
                                      width: isMobile ? 'auto' : '180px',
                                      maxWidth: isMobile ? 'none' : '180px',
                                      minWidth: isMobile ? '80px' : '180px',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      color: remarkColor,
                                      fontWeight: hasRemark ? 'bold' : 'normal'
                                    }}
                                    title={item.locationName}
                                  >
                                    {item.locationName}
                                  </td>

                                  {/* Amount to load */}
                                  <td className="text-nowrap" style={{ width: isMobile ? '65px' : '100px', maxWidth: isMobile ? '65px' : '100px' }} dir="ltr">
                                    {item.loadingAmount?.toLocaleString('en-US')}
                                  </td>

                                  {/* Remarks column - desktop only, expands to fill available space */}
                                  {!isMobile && (
                                    <td
                                      style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                      }}
                                      title={item.remark}
                                    >
                                      {item.remark}
                                    </td>
                                  )}

                                  {/* Remarks button - fixed to left */}
                                  <td className="tableRemarkBtn text-center" style={{ width: isMobile ? '40px' : '70px', minWidth: isMobile ? '40px' : '70px', maxWidth: isMobile ? '40px' : '70px' }}>
                                    <Button
                                      disabled={item?.stats === -1 || isInOrderingMode()}
                                      color={hasRemark ? 'warning' : 'success'}
                                      className="tableBtn"
                                      size="sm"
                                      onClick={() => {
                                        setShowRemarkModal({ shown: true, values: { ...item, index, date, remarkOnly: true } });
                                      }}
                                    >
                                      {isMobile ? <i className="ri-chat-1-line"></i> : t('EMPLOYEE_LOADS.REMARK') || 'הערות'}
                                    </Button>
                                  </td>

                                  {/* Cancel button - fixed to left */}
                                  {item?.stats === 1 && !isInOrderingMode() && (
                                    <td className="tableCnlBtn" style={{ width: isMobile ? '40px' : '70px', minWidth: isMobile ? '40px' : '70px', maxWidth: isMobile ? '40px' : '70px' }}>
                                      <Button
                                        disabled={false}
                                        color="danger"
                                        className="tableBtn"
                                        onClick={() => setShowLoadingCancelModal({ shown: true, value: { ...item, isCompletedLoading: true } })}
                                      >
                                        {isMobile ? <i className="ri-close-line"></i> : t(`EMPLOYEE_LOADS.CANCEL_BTN`)}
                                      </Button>
                                    </td>
                                  )}
                                  {item?.stats === -1 && !isInOrderingMode() && (
                                    <td className="tableCnlBtn" style={{ width: isMobile ? '40px' : '70px', minWidth: isMobile ? '40px' : '70px', maxWidth: isMobile ? '40px' : '70px' }}>
                                      <Button disabled={true} color="danger" className="tableBtn">
                                        {isMobile ? <i className="ri-close-line"></i> : t(`EMPLOYEE_LOADS.CANCELED_BTN`)}
                                      </Button>
                                    </td>
                                  )}
                                  {(item?.stats === 0 || isInOrderingMode()) && (
                                    <td className="tableCnlBtn" style={{ width: isMobile ? '40px' : '70px', minWidth: isMobile ? '40px' : '70px', maxWidth: isMobile ? '40px' : '70px' }}></td>
                                  )}
                                </tr>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                        {(isLoading || list.length === 0) && <NoRecords colSpan={HeaderList.length} />}
                      </tbody>
                    )}
                  </Droppable>
                </DragDropContext>
              </Table>
            </div>

            {/* Bottom row with totals */}
            <Row className="TotalCharging">
              {role !== USER_ROLE.EMPLOYEE && (
                <Col sm={3}>
                  <div className="formColumn">
                    <label>{t(`EMPLOYEE_LOADS.TOTAL_CHARGING`)}</label>
                    <NumericFormat
                      name={'amount'}
                      className="form-control"
                      value={amount}
                      allowNegative={false}
                      thousandSeparator={useThousandSeparator}
                      decimalScale={fieldDecimalScale}
                      {...(fieldDecimalScale > 0 ? { fixedDecimalScale: true } : {})}
                      disabled={true}
                      autoComplete="off"
                    />
                  </div>
                </Col>
              )}
              <Col sm={3}>
                <div className={`formColumn ${role !== USER_ROLE.EMPLOYEE ? 'emp-col' : ''}`}>
                  <label>{t(`EMPLOYEE_LOADS.REMAINING_AMOUNT_TO_EMPLOYEE`)}</label>
                  <NumericFormat
                    name={'remaining'}
                    className="form-control"
                    value={remainingAmount}
                    allowNegative={false}
                    thousandSeparator={useThousandSeparator}
                    decimalScale={fieldDecimalScale}
                    disabled={true}
                    autoComplete="off"
                  />
                </div>
              </Col>
              <Col sm={3}>
                <div className={`formColumn ${role !== USER_ROLE.EMPLOYEE ? 'emp-col' : ''}`}>
                  <label>{t(`EMPLOYEE_LOADS.REMIND_CHARGING`)}</label>
                  <NumericFormat
                    name={'totalLoadAmount'}
                    className="form-control"
                    value={totalLoadAmount}
                    allowNegative={false}
                    thousandSeparator={useThousandSeparator}
                    decimalScale={fieldDecimalScale}
                    disabled={true}
                    autoComplete="off"
                  />
                </div>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>

      {/* Modals */}
      {showRemarkModal.shown && (
        <EmployeeRemarkModal
          isOpen={showRemarkModal.shown}
          setIsOpen={setShowRemarkModal}
          values={showRemarkModal.values}
          handleSubmit={handleSubmit}
          loading={isLoading}
          setLoading={setIsLoading}
        />
      )}

      {showLoadingCancelModal.shown && (
        <EmployeeCancelLoadModal
          isOpen={showLoadingCancelModal.shown}
          setIsOpen={setShowLoadingCancelModal}
          values={showLoadingCancelModal.value}
          handleSubmit={handleSubmit}
        />
      )}

      {/* ========== Save Temp Order Modal ========== */}
      <Modal isOpen={showSaveTempModal} backdrop="static" className="modal-sm modal-dialog-centered">
        <ModalBody>
          <div className="d-flex justify-content-center align-items-center mt-3">
            <img src={warning} alt="" height="50" />
            <h3 className="mx-2 mb-0">{t('EMPLOYEE_LOADS.SAVE_TEMP_ORDER_MSG') || 'האם לשמור את הסידור הזמני?'}</h3>
          </div>
          <br />
          <div className="d-flex justify-content-end gap-2">
            <Button color="primary" className="waves-effect me-1" onClick={saveTempOrder}>
              {t('EMPLOYEE_LOADS.SAVE') || 'שמור'}
            </Button>
            <Button className="waves-effect me-1" onClick={cancelTempOrderChanges}>
              {t('EMPLOYEE_LOADS.CANCEL_BTN') || 'ביטול'}
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {/* ========== Save Permanent Order Modal ========== */}
      <Modal isOpen={showSavePermanentModal} backdrop="static" className="modal-sm modal-dialog-centered">
        <ModalBody>
          <div className="d-flex justify-content-center align-items-center mt-3">
            <img src={warning} alt="" height="50" />
            <h3 className="mx-2 mb-0">{t('EMPLOYEE_LOADS.SAVE_PERMANENT_ORDER_MSG') || 'האם לשמור את הסידור הקבוע?'}</h3>
          </div>
          <br />
          <div className="d-flex justify-content-end gap-2">
            <Button color="primary" className="waves-effect me-1" onClick={savePermanentOrder}>
              {t('EMPLOYEE_LOADS.SAVE') || 'שמור'}
            </Button>
            <Button className="waves-effect me-1" onClick={cancelPermanentOrderChanges}>
              {t('EMPLOYEE_LOADS.CANCEL_BTN') || 'ביטול'}
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <AlertModal {...compConf} />
    </>
  );
};

export default EmployeeLoadsList;